import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import GTM from '../libraries/gtm';
import Rewardful from '../libraries/rewardful';
import Wrapper from './Wrapper';
import '../styles';

GTM.init();
Rewardful.init();

const Root = ({ store }) => (
    <Provider store={store}>
        <Wrapper/>
    </Provider>
);

Root.propTypes = {
    store: PropTypes.object.isRequired,
};

export default Root;

